const React = require('react');
const PropTypes = require('prop-types');
const ArrowLeft = require('@andes/icons/ArrowLeft16');

const { Button } = require('@andes/button');

const ButtonLinkBackArrow = (props) => (
  <div className="button-back-arrow-shipping button-back-arrow__link">
    <Button hierarchy="transparent" href={props.url}>
      <div className="button-back-arrow-shipping__icon">
        <ArrowLeft />
      </div>
      {props.label}
    </Button>
  </div>
);

ButtonLinkBackArrow.propTypes = {
  kind: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  renderForm: PropTypes.bool,
};

/**
 * Default Props
 */
ButtonLinkBackArrow.defaultProps = {
  onClick: () => {},
  name: '',
  kind: 'link',
  renderForm: false,
};

module.exports = ButtonLinkBackArrow;
